// src/pages/pedidos/AjusteValorPedidoModal.js
import React, { useEffect, useState } from "react";
import Input from "../../components/input/Input";
import ModalContainer from "../../components/modalForm/ModalContainer";
import ModalHeader from "../../components/modalForm/ModalHeader";
import ModalBody from "../../components/modalForm/ModalBody";
import ModalFooter from "../../components/modalForm/ModalFooter";
import ModalTabs from "../../components/modalForm/ModalTabs";
import ModalActions, { ModalActionButton } from "../../components/modalForm/ModalActions";
import { formatCurrency, parseCurrency } from "../../utils/numberUtils";

function AjusteValorPedidoModal({ show, onClose, onApply, valorDesconto = 0, valorAcrescimo = 0, headerColors }) {
  const [tipoAjuste, setTipoAjuste] = useState("desconto");
  const [valorAcrescimoState, setValorAcrescimoState] = useState("");
  const [valorDescontoState, setValorDescontoState] = useState("");

  useEffect(() => {
    if (!show) return;

    if ((Number(valorAcrescimo) || 0) > 0) {
      setTipoAjuste("acrescimo");
    } else {
      setTipoAjuste("desconto");
    }

    setValorAcrescimoState((Number(valorAcrescimo) || 0) > 0 ? formatCurrency(valorAcrescimo) : "");
    setValorDescontoState((Number(valorDesconto) || 0) > 0 ? formatCurrency(valorDesconto) : "");
  }, [show, valorAcrescimo, valorDesconto]);

  const tituloAjuste = tipoAjuste === "acrescimo" ? "acréscimo" : "desconto";
  const valorAtual = tipoAjuste === "acrescimo" ? valorAcrescimoState : valorDescontoState;

  const handleChangeValor = (value) => {
    if (tipoAjuste === "acrescimo") {
      setValorAcrescimoState(value);
      return;
    }

    setValorDescontoState(value);
  };

  const handleBlurValor = (value) => {
    const valorFormatado = value ? formatCurrency(parseCurrency(value)) : "";

    if (tipoAjuste === "acrescimo") {
      setValorAcrescimoState(valorFormatado);
      return;
    }

    setValorDescontoState(valorFormatado);
  };

  const handleAplicar = () => {
    onApply({
      valorAcrescimo: parseCurrency(valorAcrescimoState),
      valorDesconto: parseCurrency(valorDescontoState),
    });
  };

  return (
    <ModalContainer show={show} variant="cadastro" onHide={onClose} largura="560px" contentClassName="ajuste-pedido-modal modal-operacional">
      <ModalHeader title="Ajustar valor do pedido" onHide={onClose} headerColors={headerColors} />

      <ModalBody>
        <div className="ajuste-valor-modal">
          <ModalTabs>
            <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${tipoAjuste === "desconto" ? "active" : ""}`}
              onClick={() => setTipoAjuste("desconto")}
            >
              Desconto
            </button>
            </li>
            <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${tipoAjuste === "acrescimo" ? "active" : ""}`}
              onClick={() => setTipoAjuste("acrescimo")}
            >
              Acréscimo
            </button>
            </li>
          </ModalTabs>

          <ModalTabs.Panel>
          <p className="ajuste-valor-modal__texto">
            Informe o valor do {tituloAjuste} para aplicar no pedido.
          </p>

          <Input
            label={`Valor do ${tituloAjuste}`}
            value={valorAtual}
            onChange={(e) => handleChangeValor(e.target.value)}
            onBlur={(e) => handleBlurValor(e.target.value)}
            placeholder="R$ 0,00"
            size="220px"
            autoFocus
            style={{ textAlign: 'right' }}
          />
          </ModalTabs.Panel>
        </div>
      </ModalBody>

      <ModalFooter>
        <ModalActions>
          <ModalActionButton action="close" onClick={onClose}>
            Cancelar
          </ModalActionButton>

          <ModalActionButton action="apply" onClick={handleAplicar}>
            Aplicar {tituloAjuste}
          </ModalActionButton>
        </ModalActions>
      </ModalFooter>
    </ModalContainer>
  );
}

export default AjusteValorPedidoModal;
